var $ = require('jquery');
var _ = require('underscore');
var Acknowledge = require('RecordActionAcknowledge');
var Activity = require('RecordActionActivity');
var Approve = require('RecordActionApprove');
var Authorization = require('Authorization');
var Backbone = require('backbone');
var Behaviors = require('Behaviors');
var Cancel = require('RecordActionCancel');
var ClassificationValidation = require('ClassificationValidation');
var Configuration = EY.Consultation.Lookups.Configuration;
var Delete = require('RecordActionDelete');
var DialogApprove = require('DialogApprove');
var DialogConfirmation = require('DialogConfirmation');
var DialogDeleteConfirm = require('DialogDeleteConfirm');
var DialogReturn = require('DialogReturn');
var DialogWarning = require('DialogWarning');
var Draft = require('RecordActionDraft');
var DraftValidation = require('RecordDraftValidation');
var EdwValidation = require('EdwValidation');
var Entities = require('Entities');
var Labels = EY.Consultation.Labels;
var Logger = require('Logger');
var Lookups = EY.Consultation.Lookups;
var Marionette = require('marionette');
var MultiTab = require('MultiTab')
var Preparation = require('RecordActionPreparation');
var Reassign = require('RecordActionReassign');
var RecordDocumentationSync = require('RecordDocumentationSync');
var RecordSave = require('RecordSave');
var Return = require('RecordActionReturn');
var Router = require('Router');
var Save = require('RecordActionSave');
var Status = require('RecordStatus');
var StatusType = EY.Consultation.Lookups.StatusType;
var Submit = require('RecordActionSubmit');
var Unlock = require('RecordUnlock');
var Validation = require('RecordValidation');

var back = function (model) {
    Router.navigate((!/CountryRecord/.test(model.get('link')) ? 'Record/' : 'CountryRecord' + model.get('countryId')) + model.id, { trigger: true });
};

var home = function () {
    Router.navigate('#', { trigger: true });
};

var resetUiValidation = function () {
    $("body").find('.required').removeClass('required');
    $("body").find('.required-errmsg').remove();
    $("body").find('.fa-exclamation-triangle').removeClass('fa-exclamation-triangle').removeClass('fa');
};

var resetValidation = function () {
    return {
        engagementId: { required: true, msg: Labels.ErrorMsg.replace('{0}', Labels.EngagementNumber) }
    };
};
var returnWithoutValidation = function (options) {
    var record = options.record;
    record.set('returnReason', '');
    Unlock.run(options);
    DialogReturn.show({
        model: record
    }).done(function () {
        Activity.run(options);
        Return.run(options);
        options.skipAttachmentVerification = true;
        Save.run(options).done(function () {
            Logger.LogRecordAction({ record: record, action: 'ReturnToCreator_Success' });
            options.record.set('action', 'return');
            home();
        });
    }).fail(function () {
        !!Configuration.EnableSaveMessage && record.trigger('save-fail');
    });
};
var View = Marionette.View.extend({
    behaviors: [{ behaviorClass: Authorization.RBAC, viewName: 'recordAction' }, Behaviors.MobileView, Behaviors.DisableMultipleClicks],
    events: {
        'click @ui.acknowledge': 'acknowledge',
        'click @ui.approve': 'approve',
        'click @ui.cancel': 'cancel',
        'click @ui.delete': 'delete',
        'click @ui.draft': 'draft',
        'click @ui.prepare': 'prepare',
        'click @ui.print': 'print',
        'click @ui.reassign': 'reassign',
        'click @ui.return': 'return',
        'click @ui.save': 'save',
        'click @ui.submit': 'submit'
    },
    ui: {
        acknowledge: '#acknowledge',
        approve: '#approve',
        cancel: '#cancel',
        'delete': '#delete',
        draft: '#draft',
        prepare: '#prepare',
        print: '#print',
        reassign: '#reassign',
        'return': '#return',
        save: '#save',
        submit: '#submit'
    },
    template: '#recordAction',
    onRender: function () {
        var record = this.options.record;
        var configuration = record.get('configuration');

        if (record.get('recordTypeId') === Lookups.RecordType.RequiredNotification && record.get('statusTypeId') === StatusType.UsersNotified) {
            var approverList = new Entities.Approvers(this.options.approvers.reject({ upn: '' }));
            var approvers = new Entities.Approvers(approverList.reject({ approvalNotRequired: false }));

            if (approvers.find({ upn: EY.Consultation.CurrentUser.upn, acknowledgeStatus: '' })) {
                this.ui.acknowledge.removeClass('hidden');
                this.ui.return.removeClass('hidden');
            }
        }
        if (this.options.record.get('statusTypeId') == StatusType.Preparation) {
            this.ui.prepare.html(EY.Consultation.Labels.Reassign);
        }
        if (!configuration.AllowSaveAsDraft) {
            this.ui.draft.hide();
        }
        if (!configuration.AllowPreparationPhase) {
            this.ui.prepare.hide();
        }
    },
    acknowledge: function () {
        var options = this.options;
        var record = options.record;

        Logger.LogRecordAction({record: record, action: 'Acknowledge_Started'});
        RecordDocumentationSync.validateAttachments(options).done(function(corruptedAttachments) {	
            if (corruptedAttachments.length == 0) {
                DialogConfirmation.show({
                    message: Labels.MSG033
                }).done(function () {
                    Acknowledge.run(options);
                    options.skipAttachmentVerification = true;
                    RecordSave.run(options).done(function () {
                        Logger.LogRecordAction({record: record, action: 'Acknowledge_Success'});
                        record.set('action', 'acknowledge');
                        home();
                    });
                }).fail(function () {
                    !!Configuration.EnableSaveMessage && record.trigger('save-fail');
                });
            } else {
                !!Configuration.EnableSaveMessage && record.trigger('save-fail');
                DialogWarning.show({
                    headerLabel: Labels.DialogTitleWarning,
                    saveLabel: Labels.OK,
                    message: Labels.CorruptedAttachmentMessage.replace('{0}', corruptedAttachments.toString().split(',').join('<br>'))
                });
            }
        });
    },
    approve: function () {
        var options = this.options;
        var attachments = options.attachments;
        var record = options.record;
        var configuration = record.get('configuration');
        var ui = this.ui;
        var approvers = new Entities.Approvers(options.approvers.reject(function (a) { return !a.get('upn') || a.get('approvalNotRequired'); }));
        var approver = approvers.find({ approverGroupId: record.get('approverGroupId'), upn: record.get('assignedTo') });
        var group = _.findWhere(configuration.groups, { id: approver.get('approverGroupId') });
        var history = options.history;
        var context = this;

        Logger.LogRecordAction({record: record, action: 'Approve_Started'});
        RecordDocumentationSync.validateAttachments(options).done(function(corruptedAttachments) {	
            if (corruptedAttachments.length == 0) {
                if (options.record.get('assignedTo') !== EY.Consultation.CurrentUser.upn) {
                    try {
                        Logger.logToServer(JSON.stringify({
                            recordId: record.id,
                            user: EY.Consultation.CurrentUser.upn
                        }), 'approvalBreach');
                        context.approvePatch();
                        !!Configuration.EnableSaveMessage && record.trigger('save-fail');
                    } catch (e) { //NO-OP!
                    }
                    return;
                }
                EdwValidation.run(_.extend({}, options, { group: group })).done(function () {
                    ClassificationValidation.run(options).done(function () {
                        Validation.run(options).done(function (valid, error) {
                            if (!valid && error) {
                                DialogWarning.show({
                                    message: error
                                });
                                !!Configuration.EnableSaveMessage && record.trigger('save-fail');
                            } else {
                                var checksum = record.get('validChecksum');
                                var hasTrackChangesOrComments = _.any(attachments.where(function (attachment) {

                                    var errorAttachments = attachment.get('hasComments') || attachment.get('hasTrackChanges');
                                    $("div[data-file-name='" + attachment.get("filename") + "']").find('~ .has-error').remove();
                                    if (errorAttachments) {
                                        $("<span class='attachment-error fa fa-exclamation-triangle has-error'></span>").insertAfter($("div[data-file-name='" + attachment.get("filename") + "']"));
                                        $("span.attachment-error").get(0).scrollIntoView();
                                        $('html').scrollLeft(0);
                                        $('.record-scroll').scrollLeft(0);
                                        $("span.attachment-error").parents('.collapse').collapse('show').prev().find('.error-group').addClass('fa fa-exclamation-triangle');

                                    } else {
                                        $("div[data-file-name='" + attachment.get("filename") + "']").find('~ .has-error').remove();
                                    }
                                    return errorAttachments;
                                }));

                                record.validation = _.extend(record.validation || {}, resetValidation());
                                if (((group && group.allowApprovalPostDocumentationEdits && !hasTrackChangesOrComments) || checksum) && valid) {
                                    var message = record.get('recordTypeId') === EY.Consultation.Lookups.RecordType.RequiredNotification ? Labels.MSG012 :
                                        approver.get('upn') !== approvers.last().get('upn') ? Labels.MSG016 : Labels.MSG017;
                                    message = group.id === 'PartnerInCharge' && !record.get('validateEngagement') ? Labels.EnagementManualInfo + message : message;

                                    Activity.run(options);
                                    DialogApprove.show({
                                        message: message,
                                        model: approver,
                                        record: record
                                    }).done(function () {
                                        _.extend(approver.validation, { recusal: function () { return ''; }, independence: function () { return ''; } });
                                        record.set('validChecksum', true);
                                        Approve.run(options);
                                        Status.set(options);
                                        Unlock.run(options);
                                        options.skipAttachmentVerification = true;
                                        RecordSave.run(options).done(function () {
                                            Logger.LogRecordAction({record: record, action: 'Approve_Success'});
                                            record.set('action', 'approve');
                                            home();
                                        });
                                    }).fail(function () {
                                        !!Configuration.EnableSaveMessage && record.trigger('save-fail');
                                        _.extend(approver.validation, { recusal: function () { return ''; }, independence: function () { return ''; } });
                                        approver.set({ comments: '', recusal: approver.get('recusal') === '' ? '' : false, independence: approver.get('independence') === '' ? '' : false });
                                        record.set({ approverGroupId: history.approverGroupId, statusTypeId: history.statusTypeId, statusResourceKey: history.statusResourceKey });
                                    });
                                } else if (group && group.allowApprovalPostDocumentationEdits && hasTrackChangesOrComments) {
                                    DialogWarning.show({
                                        message: Labels.MSG018
                                    });
                                    !!Configuration.EnableSaveMessage && record.trigger('save-fail');
                                } else if (!checksum && valid) {
                                    Activity.run(options);
                                    options.history = _.clone(record.attributes);
                                    options.history.attachments = options.attachments.toJSON();
                                    returnWithoutValidation(options)
                                } else if (!valid && record.get('invalidEngagement')) {
                                    !!Configuration.EnableSaveMessage && record.trigger('save-fail');
                                    record.set({ approverGroupId: history.approverGroupId, statusTypeId: history.statusTypeId, statusResourceKey: history.statusResourceKey });
                                }
                            }
                        });
                    });
                });
            } else {
                !!Configuration.EnableSaveMessage && record.trigger('save-fail');
                DialogWarning.show({
                    headerLabel: Labels.DialogTitleWarning,
                    saveLabel: Labels.OK,
                    message: Labels.CorruptedAttachmentMessage.replace('{0}', corruptedAttachments.toString().split(',').join('<br>'))
                });
            }
        });
    },
    approvePatch: function approvePatch() {
        var options = this.options;
        var record = this.options.record;

        Logger.LogRecordAction({record: record, action: 'ApprovePatch_Started'});
        RecordDocumentationSync.validateAttachments(options).done(function(corruptedAttachments) {	
            if (corruptedAttachments.length == 0) {
                Validation.run(options).done(function (valid, error) {
                    if (valid) {
                        options.skipAttachmentVerification = true;
                        RecordSave.run(options).done(function () {
                            Logger.LogRecordAction({record: record, action: 'ApprovePatch_Success'});
                            record.set('action', 'approve');
                            home();
                        });
                    } else if (error) {
                        Logger.LogRecordAction({record: record, action: 'ApprovePatch_Error', error: error});
                        DialogWarning.show({
                            message: error
                        });
                    }
                });
            } else {
                DialogWarning.show({
                    headerLabel: Labels.DialogTitleWarning,
                    saveLabel: Labels.OK,
                    message: Labels.CorruptedAttachmentMessage.replace('{0}', corruptedAttachments.toString().split(',').join('<br>'))
                });
            }
        });
    },
    cancel: function () {
        var options = this.options;
        var record = options.record;

        Cancel.run(options).done(function () {
            if (record.isNew()) {
                home();
            } else {
                if (MultiTab.isOpenedInOriginalTab({ isOpenedByCurrentUser: record.get('isOpenedByCurrentUser') })) {
                    Unlock.run(options);
                    //We are saving history because we need to undo all the changes that the user has done.
                    record.save(options.history, {validate: false}).done(function() {
                        back(record);
                    });
                    return;
                }
                back(record);
            }
        });
    },
    'delete': function () {  
        var options = this.options;
        var record = options.record;

        Logger.LogRecordAction({record: record, action: 'Delete_Started'});
        DialogDeleteConfirm.show({
            model: options.record
        }).done(function () {
            options.record.set('action', 'delete');
            Delete.run(options).done(function () {
                Logger.LogRecordAction({record: record, action: 'Delete_Success'});
                home();
            });
        }).fail(function () {
            !!Configuration.EnableSaveMessage && record.trigger('save-fail');
        });
    },
    draft: function () {
        var options = this.options;
        var record = options.record;

        Logger.LogRecordAction({record: record, action: 'SaveAsDraft_Started'});
        this.removeApproversWithoutUPN();
        resetUiValidation();

        RecordDocumentationSync.validateAttachments(options).done(function(corruptedAttachments) {	
            if (corruptedAttachments.length == 0) {
                DraftValidation.run(options).done(function () {
                    Activity.run(options);
                    Draft.run(options);
                    Unlock.run(options);
                    options.skipAttachmentVerification = true;
                    Save.run(options).done(function () {
                        Logger.LogRecordAction({record: record, action: 'SaveAsDraft_Success'});
                        back(record);
                    });
                });
            } else {
                !!Configuration.EnableSaveMessage && record.trigger('save-fail');
                DialogWarning.show({
                    headerLabel: Labels.DialogTitleWarning,
                    saveLabel: Labels.OK,
                    message: Labels.CorruptedAttachmentMessage.replace('{0}', corruptedAttachments.toString().split(',').join('<br>'))
                });
            }
        });
    },
    removeApproversWithoutUPN: function () {
        var options = this.options;
        var approvers = options.approvers;
        
        approvers.clone().each(function (approver) {
            var hasRank = approver.get('approverGroupId').match(/TeamMember|AdvanceApprover|RequiredNotification/);
            
            if(hasRank){
                var grouped = _.groupBy(approvers.toJSON(), 'approverGroupId');
                var group = approver.get('approverGroupId');
                var upn = approver.get('upn');
                
                if (!upn && (grouped[group].length > 1) && (approver.id !== _.chain(grouped[group]).sortBy('order').first().value().id)) {
                    approvers.remove(approver);
                    approver.trigger('change');
                }
            }
        });
    },
    prepare: function () {
        var options = this.options;
        var record = options.record;

        Logger.LogRecordAction({record: record, action: 'SubmitForPreparation_Started'});
        RecordDocumentationSync.validateAttachments(options).done(function(corruptedAttachments) {	
            if (corruptedAttachments.length == 0) {
                Validation.run(options).done(function (valid, error) {
                    if (valid) {
                        record.isNew() ? Activity.run(options) : "";
                        Preparation.run(options).done(function () {
                            !record.isNew() ? Activity.run(options) : "";
                            Unlock.run(options);
                            options.skipAttachmentVerification = true;
                            RecordSave.run(options).done(function () {
                                Logger.LogRecordAction({record: record, action: 'SubmitForPreparation_Success'});
                                options.record.set('action', 'preparation');
                                home();
                            });
                        }).fail(function () {
                            !!Configuration.EnableSaveMessage && record.trigger('save-fail');
                        });
                    } else if (error) {
                        Logger.LogRecordAction({record: record, action: 'SubmitForPreparation_Error', error: error});
                        !!Configuration.EnableSaveMessage && record.trigger('save-fail');
                        DialogWarning.show({
                            message: error
                        });
                    }
                });
            } else {
                !!Configuration.EnableSaveMessage && record.trigger('save-fail');
                DialogWarning.show({
                    headerLabel: Labels.DialogTitleWarning,
                    saveLabel: Labels.OK,
                    message: Labels.CorruptedAttachmentMessage.replace('{0}', corruptedAttachments.toString().split(',').join('<br>'))
                });
            }
        });
    },
    print: function () {
        window.print();
    },
    reassign: function () {
        var options = this.options;
        var record = options.record;

        Logger.LogRecordAction({record: record, action: 'Reassign_Started'});
        RecordDocumentationSync.validateAttachments(options).done(function(corruptedAttachments) {	
            if (corruptedAttachments.length == 0) {
                Validation.run(options).done(function (valid, error) {
                    if (valid) {
                        Reassign.run(options).done(function () {
                            Activity.run(options);
                            Status.set(options);
                            Unlock.run(options);
                            options.skipAttachmentVerification = true;
                            RecordSave.run(options).done(function () {
                                Logger.LogRecordAction({record: record, action: 'Reassign_Success'});
                                options.record.set('action', 'reassign');
                                home();
                            });
                        }).fail(function () {
                            !!Configuration.EnableSaveMessage && record.trigger('save-fail');
                            DialogWarning.show({
                                message: Labels.MSG009
                            });
                        });
                    } else if (error) {
                        Logger.LogRecordAction({record: record, action: 'Reassign_Error', error: error});
                        !!Configuration.EnableSaveMessage && record.trigger('save-fail');
                        DialogWarning.show({
                            message: error
                        });
                    }
                });
            } else {
                !!Configuration.EnableSaveMessage && record.trigger('save-fail');
                DialogWarning.show({
                    headerLabel: Labels.DialogTitleWarning,
                    saveLabel: Labels.OK,
                    message: Labels.CorruptedAttachmentMessage.replace('{0}', corruptedAttachments.toString().split(',').join('<br>'))
                });
            }
        });
    },
    'return': function () {
        var options = this.options;
        var record = options.record;

        Logger.LogRecordAction({record: record, action: 'ReturnToCreator_Started'});
        RecordDocumentationSync.validateAttachments(options).done(function(corruptedAttachments) {	
            if (corruptedAttachments.length == 0) {
                Validation.run(options).done(function (valid, error) {
                    if (valid) {
                        returnWithoutValidation(options);
                    } else if (error) {
                        Logger.LogRecordAction({record: record, action: 'ReturnToCreator_Error', error: error});
                        !!Configuration.EnableSaveMessage && record.trigger('save-fail');
                        DialogWarning.show({
                            message: error
                        });
                    }
                });
            } else {
                !!Configuration.EnableSaveMessage && record.trigger('save-fail');
                DialogWarning.show({
                    headerLabel: Labels.DialogTitleWarning,
                    saveLabel: Labels.OK,
                    message: Labels.CorruptedAttachmentMessage.replace('{0}', corruptedAttachments.toString().split(',').join('<br>'))
                });
            }
        });
    },
    save: function () {
        var options = this.options;
        var record = this.options.record;

        Logger.LogRecordAction({record: record, action: 'Save_Started'});
        RecordDocumentationSync.validateAttachments(options).done(function(corruptedAttachments) {	
            if (corruptedAttachments.length == 0) {
                Validation.run(options).done(function (valid, error) {
                    if (valid) {
                        DialogWarning.show({
                            message: Labels.MSG020
                        }).always(function () {
                            Activity.run(options);
                            Unlock.run(options);
                            options.skipAttachmentVerification = true;
                            RecordSave.run(options).done(function () {
                                Logger.LogRecordAction({record: record, action: 'Save_Success'});
                                options.record.set('action', 'save');
                                back(record);
                            });
                        });
                    } else if (error) {
                        Logger.LogRecordAction({record: record, action: 'Save_Error', error: error});
                        !!Configuration.EnableSaveMessage && record.trigger('save-fail');
                        DialogWarning.show({
                            message: error
                        });
                    }
                });
            } else {
                !!Configuration.EnableSaveMessage && record.trigger('save-fail');
                DialogWarning.show({
                    headerLabel: Labels.DialogTitleWarning,
                    saveLabel: Labels.OK,
                    message: Labels.CorruptedAttachmentMessage.replace('{0}', corruptedAttachments.toString().split(',').join('<br>'))
                });
            }
        });
    },
    submit: function () {
        var context = this;
        var options = this.options;
        var record = options.record;
        var attachments = options.attachments;
        var user = EY.Consultation.CurrentUser;

        Logger.LogRecordAction({record: record, action: 'Submit_Started'});
        RecordDocumentationSync.validateAttachments(options).done(function(corruptedAttachments) {	
            if (corruptedAttachments.length == 0) {
                ClassificationValidation.run(options).done(function () {
                    Validation.run(options).done(function (valid, error) {
                        var hasTrackChangesOrComments = _.any(attachments.where(function (attachment) {
                            var errorAttachments = attachment.get('hasComments') || attachment.get('hasTrackChanges');
                            $("div[data-file-name='" + attachment.get("filename") + "']").find('~ .has-error').remove();
                            if (errorAttachments) {
                                $("<span class='attachment-error fa fa-exclamation-triangle has-error'></span>").insertAfter($("div[data-file-name='" + attachment.get("filename") + "']"));
                                $("span.attachment-error").get(0).scrollIntoView();
                                $('html').scrollLeft(0);
                                $('.record-scroll').scrollLeft(0);
                                $("span.attachment-error").parents('.collapse').collapse('show').prev().find('.error-group').addClass('fa fa-exclamation-triangle');

                            } else {
                                $("div[data-file-name='" + attachment.get("filename") + "']").find('~ .has-error').remove();
                            }
                            return errorAttachments;
                        }));

                        if (valid && !hasTrackChangesOrComments) {
                            DialogConfirmation.show({
                                message: Labels.MSG007
                            }).done(function () {

                                Activity.run(_.extend(options, { action: "submit" }));
                                Submit.run(options);
                                Status.set(options);

                                if (record.get('assignedTo') === user.upn && record.get('createdBy') === user.upn) {
                                    context.approve();
                                } else {
                                    Unlock.run(options);
                                    RecordSave.run(options).done(function () {
                                        Logger.LogRecordAction({record: record, action: 'Submit_Success'});
                                        options.record.set('action', 'submit');
                                        home();
                                    });
                                }
                            }).fail(function () {
                                !!Configuration.EnableSaveMessage && record.trigger('save-fail');
                            });
                        } else if (hasTrackChangesOrComments) {
                            !!Configuration.EnableSaveMessage && record.trigger('save-fail');
                            DialogWarning.show({
                                message: Labels.MSG018
                            });
                        } else if (error) {
                            Logger.LogRecordAction({record: record, action: 'Submit_Error', error: error});
                            !!Configuration.EnableSaveMessage && record.trigger('save-fail');
                            DialogWarning.show({
                                message: error
                            });
                        }
                    });
                });
            } else {
                !!Configuration.EnableSaveMessage && record.trigger('save-fail');
                DialogWarning.show({
                    headerLabel: Labels.DialogTitleWarning,
                    saveLabel: Labels.OK,
                    message: Labels.CorruptedAttachmentMessage.replace('{0}', corruptedAttachments.toString().split(',').join('<br>'))
                });
            }
        });
    }
});

module.exports.start = function (options) {
    var region = options.region;
    //Behaviors need to be set here as ActionStatus needs options which are only 
    //available within start method.
    options.behaviors = [
        { behaviorClass: Authorization.RBAC, viewName: 'recordAction' }, 
        Behaviors.MobileView, 
        Behaviors.DisableMultipleClicks, 
        { 
            behaviorClass: Behaviors.ActionStatus, 
            model: options.record,
            successEvents: 'save delete',
            failEvent: 'save-fail',
        }
    ];

    region.show(new View(options));
};


// WEBPACK FOOTER //
// ./js/Modules/Record/Action/RecordAction.js